import * as globals from '@wandb/weave/common/css/globals.styles';
import {useBooleanState} from '@wandb/weave/common/util/hooks';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {IconMegaphone} from '@wandb/weave/components/Icon';
// @todo: Migrate to 'Tooltip' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {TooltipDeprecated} from '@wandb/weave/components/TooltipDeprecated';
import React, {type FC, memo} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {envIsPublicCloud} from '../../../config';
import {
  useIsAdminModeActiveAndIsNotLocalEnv,
  viewingAs,
} from '../../../util/admin';
import {
  openBeamer,
  useBeamerAvailable,
  useBeamerHasNewPosts,
} from '../../../util/beamer';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button, Wrapper} from './NavResources';

const NavWhatsNewButtonComp: FC = () => {
  const {
    state: tooltipOpen,
    setTrue: openTooltip,
    setFalse: closeTooltip,
  } = useBooleanState(false);

  const isAdminMode =
    useIsAdminModeActiveAndIsNotLocalEnv() || viewingAs() !== '';
  const hasNewPosts = useBeamerHasNewPosts();
  const beamerAvailable = useBeamerAvailable();

  if (!envIsPublicCloud || beamerAvailable === false) {
    return null;
  }

  return (
    <Wrapper marginRight={7}>
      <TooltipDeprecated
        position="bottom center"
        open={tooltipOpen}
        onOpen={openTooltip}
        onClose={closeTooltip}
        trigger={
          <Button
            active={false}
            showAdminBanner={isAdminMode}
            aria-label="What's new"
            onClick={openBeamer}>
            <Icon />
            {hasNewPosts && <AlertPill showAdminBanner={isAdminMode} />}
          </Button>
        }>
        What's new
      </TooltipDeprecated>
    </Wrapper>
  );
};

const NavWhatsNewButton = memo(NavWhatsNewButtonComp);

export default NavWhatsNewButton;

const Icon = styled(IconMegaphone)`
  display: block;
  width: 24px;
  height: 24px;
`;
Icon.displayName = 'S.Icon';

const AlertPill = styled.div<{showAdminBanner?: boolean}>`
  width: 14px;
  height: 14px;
  background-color: ${globals.RED_500};
  border-radius: 50%;
  border: ${props =>
    props.showAdminBanner
      ? `2px solid ${globals.GOLD_550}`
      : `2px solid ${globals.MOON_950}`};
  position: absolute;
  top: -1px;
  right: -1px;
`;
AlertPill.displayName = 'S.AlertPill';
